// extracted by mini-css-extract-plugin
module.exports = {"main":"BBPicture_main__1O0f_","list":"BBPicture_list__tnjnp","firstItemBold":"BBPicture_firstItemBold__yJhof","link":"BBPicture_link__26gvG"};